/**
 * Shared constants for Create Your Own (CYO) module
 */

export const PHONE_NUMBER = "08000436644";
export const PHONE_NUMBER_DISPLAY = "0800 043 6644";
export const PHONE_LINK = `tel:${PHONE_NUMBER}`;

export const CALL_TO_ACTION_TEXT =
  "Speak with someone who's been there! Call us on";

export const MAX_GROUP_SIZE = 32;
export const MAX_NIGHTS = 10;
export const MAX_ROUNDS = 10;
